import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Polices self-hosted via @fontsource — équivalent SPA de next/font/google
// dans apps/web/app/layout.tsx (next/font gère lui-même le self-hosting ;
// @fontsource fait le même travail ici : fichiers de police embarqués dans le
// build, AUCUNE requête vers fonts.googleapis.com/fonts.gstatic.com au
// runtime). Mêmes graisses que l'original :
//   Playfair Display : 600, 700, 900 (titres, cf. tailwind.config.ts fontFamily.display)
//   Jost              : 300, 400, 500, 600, 700 (corps de texte, fontFamily.body)
import "@fontsource/playfair-display/600.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/playfair-display/900.css";
import "@fontsource/jost/300.css";
import "@fontsource/jost/400.css";
import "@fontsource/jost/500.css";
import "@fontsource/jost/600.css";
import "@fontsource/jost/700.css";

import "@/styles/globals.css";
import { App } from "@/App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
